export const joinPath = (prefix: string, name: string) => (prefix ? `${prefix}.${name}` : name);
